module.exports = __webpack_public_path__ + "img/banana-wh.850baf5a.svg";